import React from "react";
import { LegalLayout, LegalBlock } from "@/components/LegalLayout";
import { COMPANY } from "@/data/site";

export default function Impressum() {
  return (
    <LegalLayout
      title="Impressum"
      subtitle="Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)"
      testId="impressum-page"
    >
      <LegalBlock heading="Diensteanbieter">
        <p className="font-semibold text-neutral-900">{COMPANY.name}</p>
        <p>{COMPANY.street}</p>
        <p>{COMPANY.city}</p>
        <p>Deutschland</p>
      </LegalBlock>

      <LegalBlock heading="Vertreten durch">
        <p>Inhaber: Herr Kilic</p>
        <p className="text-neutral-400">
          (Bitte vollständigen Vor- und Nachnamen des Inhabers ergänzen.)
        </p>
      </LegalBlock>

      <LegalBlock heading="Kontakt">
        <p>
          Telefon:{" "}
          <a href={`tel:${COMPANY.phoneTel}`} className="text-[var(--kilic-blue)]">
            {COMPANY.phoneDisplay}
          </a>
        </p>
        <p>
          E-Mail:{" "}
          <a href={`mailto:${COMPANY.email}`} className="text-[var(--kilic-blue)]">
            {COMPANY.email}
          </a>
        </p>
      </LegalBlock>

      <LegalBlock heading="Umsatzsteuer-Identifikationsnummer">
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
        </p>
        <p className="text-neutral-400">
          (Bitte USt-IdNr. bzw. Steuernummer ergänzen, sofern vorhanden.)
        </p>
      </LegalBlock>

      <LegalBlock heading="Redaktionell verantwortlich">
        <p>{COMPANY.name}</p>
        <p>
          {COMPANY.street}, {COMPANY.city}
        </p>
      </LegalBlock>

      <LegalBlock heading="Verbraucherstreitbeilegung / Universalschlichtungsstelle">
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </LegalBlock>

      <LegalBlock heading="Haftung für Inhalte">
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
          §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
        </p>
      </LegalBlock>

      <LegalBlock heading="Haftung für Links">
        <p>
          Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf
          deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
          fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
          verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich.
        </p>
      </LegalBlock>

      <LegalBlock heading="Urheberrecht">
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind
          als solche gekennzeichnet. Downloads und Kopien dieser Seite sind nur
          für den privaten, nicht kommerziellen Gebrauch gestattet.
        </p>
      </LegalBlock>
    </LegalLayout>
  );
}
